import { useReducer } from "react";
import { initialState, refOptionsReducer } from "../reducers";
import { RefOptionsAction } from "../types";

export function useRefOptionsState() {
  const [state, dispatch] = useReducer(refOptionsReducer, initialState);

  return {
    state,
    dispatch,
  };
}

export type RefOptionsDispatch = (action: RefOptionsAction) => void;
